import { AllieLink } from "../../../components";
import { AllieBackArrow } from "../../../styling/icons";

export const AllieGoBackLink: React.FC<{ href: string }> = ({ href }) => (
  <AllieLink
    size="large"
    icon={AllieBackArrow}
    iconPosition="center"
    href={href}
    className="go-back-link"
  />
);
